/* eslint-disable no-console */
/* eslint-disable eqeqeq */
export default function deprecated(fn, message) {
    if (process.env.NODE_ENV == 'production') {
        return fn;
    }
    if (message == null) {
        throw new Error('Deprecation requires a message');
    }
    let warned = false;

    return function(...args) {
        if (!warned && console.trace != null) {
            console.trace(`%cDeprecated: ${message}`, 'background: #ff0');
            warned = true;
        }

        return fn.apply(this, args);
    };
}



// WEBPACK FOOTER //
// ./src/deprecated.js